import React, { useState } from 'react';
import { SectionHeader } from '../components/UI';
import { FAQS } from '../data/courseData';
import styles from './FAQ.module.css';

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section className={styles.section} id="faq">
      <div className={styles.container}>
        <SectionHeader
          label="FAQs"
          title="Questions we hear before every batch"
          center
        />

        <div
          className={styles.list}
          itemScope
          itemType="https://schema.org/FAQPage"
        >
          {FAQS.map((faq, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`${styles.item} ${isOpen ? styles.open : ''}`}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <button
                  className={styles.question}
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  itemProp="name"
                >
                  <span>{faq.q}</span>
                  <span className={`${styles.icon} ${isOpen ? styles.iconOpen : ''}`}>+</span>
                </button>

                <div
                  className={`${styles.answer} ${isOpen ? styles.answerOpen : ''}`}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p itemProp="text">{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.cta}>
          <p>Still have questions?</p>
          <a href="tel:+917387136569" className={styles.ctaBtn}>Talk to Us </a>
        </div>
      </div>
    </section>
  );
}
